module.exports = __webpack_public_path__ + "static/img/horror-hand-v3.c6d66359.png";